
    import {useStore} from "@/store";
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";

    interface State {
        dataList: object[];
        vin: string;
    }

    export default defineComponent({
        name: "BaseInfo",
        setup() {
            let state: State = reactive({
                dataList: [],
                vin: '',
            })
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {basicItemInfos, vin} = data;
                state.dataList = basicItemInfos.filter(function (item: any){ return item.fieldName !== '车架号'});
                state.vin = vin;
            })
            return {
                state
            }
        }
    })
